import apiClient from './apiClient';

export const assignWalletToTournament = async (address, tournamentId, hash) => {
  try {
    // Private tournaments require the invitation hash as a query param so the
    // backend's wallet-assignment hash gate (B-C2) lets the joiner through.
    // Owners are exempt server-side, so the hash is optional in the create
    // flow but required for joiners coming in via /tournaments/:id/join?hash=.
    const url = hash ? `/wallet-assignments?hash=${encodeURIComponent(hash)}` : '/wallet-assignments';
    const response = await apiClient.post(url, {
      data: {
        address: address,
        tournament: tournamentId
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error?.message || 'Failed to assign wallet to tournament');
  }
};

export const getWalletAssignmentForTournament = async (tournamentId) => {
  try {
    const response = await apiClient.get(`/wallet-assignments/tournaments/${tournamentId}`);

    return response.data?.data;
  } catch (error) {
    // 404 means no assignment exists yet — return null so callers can branch (GET-first pattern)
    if (error.response?.status === 404) {
      return null;
    }
    throw new Error(error.response?.data?.error?.message || 'Failed to fetch wallet assignment for tournament');
  }
};

